import React, {useEffect} from 'react';
import Header from '../Templates/Shared/Header';
import styles from '../Templates/Styles/staticpage.module.scss';
import htmr from 'htmr';
import careersPageData from '../../data/staticPages/careersPage.json';
import Footer from '../Templates/Shared/Footer';
import Helmet from 'react-helmet';
import SEO from '../Templates/SEO';
import {getCanonicalURLs, migratedPartners, handleScroll} from
  '../Templates/Shared/StaticPageService';
import {getParameterByName} from '../Templates/Shared/Utils';
import cookie from 'react-cookies';

const Careers = () => {
  const locale = 'en';
  const canonicals = getCanonicalURLs(careersPageData.seo.canonicalurls);

  useEffect(() => {
    const utmSource = cookie.load(
        'utm_source') || getParameterByName('utm_source');
    const isMigratedPartner = migratedPartners.includes(utmSource);
    const id = document.getElementById('signupcta');
    if (isMigratedPartner) {
      if (id) {
        id.href = `https://learning.upskillist.com/${utmSource}`;
      }
    } else {
      if (id) {
        if (utmSource?.toLowerCase()?.startsWith('sc') ||
          utmSource?.toLowerCase()?.startsWith('stack')) {
          id.href = `https://learning.upskillist.com/stackcommerce`;
        } else {
          id.href = `https://learning.upskillist.com/?utm_source=${utmSource}&utm_medium=partners`;
        }
      }
    }
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div>
      <SEO
        locale={locale}
        title={careersPageData.seo.title}
        description={careersPageData.seo.description}
        image={''}
        canonicalUrls={canonicals}
        languageCanonicals={careersPageData.languageCanonicals}
        schemaMarkup={null}
      />
      <Helmet>
        <script>
          window.dataLayer=window.dataLayer||[];
        </script>
      </Helmet>
      <Header locale={locale} />
      <main className={`career container ${styles.staticPage}`}>
        {careersPageData.sections.map((section) => {
          let content = '<div></div>';
          if (section.pagesection) {
            content = section.pagesection.content;
          }
          return (htmr(content));
        })}
      </main>
      <Footer />
    </div>
  );
};

export default Careers;
